import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'PAYMENT_METHOD_SET_AS_DEFAULT_ERROR':
      return action.error;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'PAYMENT_METHOD_SET_AS_DEFAULT_LOADING':
      return action.loading;

    default:
      return state;
  }
}

export function result(state = null, action) {
  switch (action.type) {
    case 'PAYMENT_METHOD_SET_AS_DEFAULT_SUCCESS':
      return action.result;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, result });
